import React from 'react'
import View from './view.js'
import useOnClickOutside from 'use-onclickoutside'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useFloating, offset, autoUpdate } from '@floating-ui/react-dom'

export default function Logic(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let { refs, x, y } = useFloating({
    placement: 'top',
    middleware: [offset({ mainAxis: 4, crossAxis: 8 })],
    whileElementsMounted: autoUpdate,
  })

  useOnClickOutside(refs.floating, event => {
    if (
      event.target === refs.reference.current ||
      refs.reference.current?.contains(event.target)
    ) {
      return
    }
    setFlowTo(normalizePath(props.viewPath, 'No'))
  })

  return (
    <View
      {...props}
      setOuterRef={refs.setReference}
      setInnerRef={refs.setFloating}
      left={x ?? 0}
      top={y ?? 0}
    />
  )
}
